module.exports = __webpack_public_path__ + "img/TZS09467.b04f0b6f.jpeg";